<template>
  <section class="box p-4">
    <div
    ref="elGrafica"
    style="height:400px;"
    class="w-full"
    />
  </section>
</template>

<script>
import * as echarts from 'echarts'
import { reactive, ref } from '@vue/reactivity'
import { onMounted, watch } from '@vue/runtime-core'
import { apiFarmacoVigilancia } from '../../services'
import currency from 'currency.js'
import { messageWarning } from '../../../../../../../libs/mensajes'
import axios from 'axios'
export default {
  name: 'famacoVigilancia',
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const elGrafica = ref({})
    let chartInstance = reactive({})
    const chartData = ref({
      data: [],
      legend: {
        interacciones: 0,
        pacientes: 0
      }
    })

    onMounted(() => {
      initChart()
    })
    watch(props.filters, (filter) => {
      if ([null, undefined, ''].includes(filter.client) ||
        [null, undefined, ''].includes(filter.year)
      ) return
      fetchResults(filter)
    })

    const initChart = () => {
      chartInstance = echarts.init(elGrafica.value)
      const option = {
        title: {
          // text: 'Farmacovigilancia',
          subtext: '',
          left: 'left'
        },
        toolbox: {
          top: 15,
          right: 15,
          feature: {
            myTool1: {
              show: true,
              right: 15,
              top: 10,
              title: 'Descargar detallado',
              icon: 'image:///images/excel.png',
              onclick: () => {
                descargarExcel()
              }
            },
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: 15,
          right: 15,
          bottom: 50,
          top: 85,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: true,
            itemStyle: {
              color: '#3CB2EF'
            },
            label: {
              show: true,
              position: 'top',
              formatter (a) {
                return `${a.value}%`
              }
            }
          }
        ]
      }
      chartInstance.setOption(option)
      eventsChart()
    }

    const eventsChart = () => {
      window.addEventListener('resize', evt => {
        chartInstance.resize()
      })
    }

    const reloadChart = () => {
      const option = {
        title: {
          subtext: `Total Interacciones: ${currency(chartData.value.legend.interacciones, { precision: 0, symbol: '', separator: '.' }).format()} Cantidad Pacientes: ${chartData.value.legend.pacientes}`
        },
        xAxis: {
          data: chartData.value.data.map(a => a.riesgo)
        },
        series: [
          {
            data: chartData.value.data.map(a => a.Porcentaje)
          }
        ]
      }

      chartInstance.setOption(option)
    }

    const fetchResults = (filter) => {
      apiFarmacoVigilancia(filter).then(({ status, data }) => {
        chartData.value = data
        reloadChart()
      }).catch((err) => {
        console.log(err.message)
      })
    }

    const descargarExcel = () => {
      if (!props.filters.client) {
        messageWarning('Por favor seleccione un cliente para generar el reporte en excel')
        return false
      }
      const url = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}/execution-report/interactions-report-chart`
      const res = axios.getUri({ url, params: props.filters })
      window.open(res, '_blank')
    }

    return {
      elGrafica
    }
  }
}
</script>
